(function($){

    // Menu animations
    
/* 
Collapseable Menu Button Animation
*/

    var $menuBtn = $("#js-c-menu_btn");

    $menuBtn.on("click", function (e) {
        $menuBtn.toggleClass("is-active");

        $("body").toggleClass("has-menu-open");
        $(".c-nav").toggleClass("made-active");
    });




  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 400) {
        //clearHeader, not clearheader - caps H
        $('.c-site-header').addClass("active");
         $('body').addClass("menu-active");
    }else{
        $('.c-site-header').removeClass("active");
         $('body').removeClass("menu-active");
    }
});


    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});

    // Video Popup
    $(function() {
        $('.c-video-button a').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            disableOn: 320,
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            enabled: false
        });
    });

    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });

    //Parallax Animation
    var image = document.getElementsByClassName('trust');
          new trustPara(image, {
          maxTransition: 300
    });


          // Animate text + images
    document.querySelectorAll('.hero__column h1, .hero__column h2, .site-content section:not(.row--curve) .container > p, .site-content section:not(.row--curve) .container > ul, .site-content section:not(.row--curve) .container > h1, .site-content section:not(.row--curve) .container > h2, .site-content section:not(.row--curve) .container > h3, .site-content section:not(.row--curve) .container > h4, .site-content section:not(.row--curve) .container > h5, .site-content section:not(.row--curve) .wp-block-column > p, .site-content section:not(.row--curve) .wp-block-column > ul, .site-content section:not(.row--curve) .wp-block-column > h1, .site-content section:not(.row--curve) .wp-block-column > h2, .site-content section:not(.row--curve) .wp-block-column > h3, .site-content section:not(.row--curve) .wp-block-column > h4, .site-content section:not(.row--curve) .wp-block-column > h5, .site-content .wp-block-column > figure:not(.team__member--photo), .site-content section:not(.row--curve) .text-media__column > p, .site-content section:not(.row--curve) .text-media__column > ul, .site-content section:not(.row--curve) .text-media__column > h1, .site-content section:not(.row--curve) .text-media__column > h2, .site-content section:not(.row--curve) .text-media__column > h3, .site-content section:not(.row--curve) .text-media__column > h4, .site-content section:not(.row--curve) .text-media__column > h5, .site-content .careers__card, .site-content section:not(.row--curve) .wp-block-buttons, .site-content .container > figure, .site-content .container > .wp-block-image').forEach(function (element) {
        element.setAttribute('data-aos', 'fade-up')
		element.setAttribute('data-aos-anchor-placement', 'top-bottom')
        element.setAttribute('data-aos-duration', '1000')
    });

    // Initiate aos animations
	AOS.init();


    // Remove empty paragraphs
    $('p:empty:not([role])').remove();

})(jQuery);